import React from 'react';
import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyCompReportSettings } from '../../arc/models/arc-epi-props';
import { DomesticMap } from './domestic-map';
import { HomeMap } from './home-map';
import { InternationalMap } from './international-map';
import { MapContext } from '../models';

export function ClergyCompReportMap() {
	const context = useSelector<TcsmStates, MapContext>(state => state.clergyCompReportState.mapContext);
	const settings = useSelector<TcsmStates, ClergyCompReportSettings>(state => state?.epiProps?.clergyCompReportSettingsState?.epiContent);
	switch (context) {
		case MapContext.LANDING:
			return <HomeMap settings={settings} />;
		case MapContext.DOMESTIC:
			return <DomesticMap />;
		case MapContext.INTERNATIONAL:
			return <InternationalMap />;
		default:
			return <HomeMap settings={settings} />;
	}
}